/**
 * List of nationalities for dropdowns (e.g. Create User form).
 * Backend accepts nationality as a string; no API change required.
 */
export const NATIONALITIES = [
  "Egyptian",
  "Saudi Arabian",
  "Emirati",
  "Kuwaiti",
  "Qatari",
  "Bahraini",
  "Omani",
  "Jordanian",
  "Lebanese",
  "Syrian",
  "Palestinian",
  "Iraqi",
  "Yemeni",
  "Sudanese",
  "Libyan",
  "Tunisian",
  "Algerian",
  "Moroccan",
  "American",
  "British",
  "Canadian",
  "Australian",
  "French",
  "German",
  "Italian",
  "Spanish",
  "Dutch",
  "Russian",
  "Chinese",
  "Japanese",
  "Indian",
  "Pakistani",
  "Bangladeshi",
  "Turkish",
  "Iranian",
  "Indonesian",
  "Malaysian",
  "Philippine",
  "South African",
  "Nigerian",
  "Kenyan",
  "Ethiopian",
  "Other",
];
